const allTableCheckbox = document.querySelectorAll(
    ".invoices-table table tbody .checkbox input"
);
const toggleAllTableCheckbox = document.querySelector(
    ".invoices-table table thead .checkbox input"
);

if (allTableCheckbox.length) {
    if (toggleAllTableCheckbox) {
        toggleAllTableCheckbox.addEventListener("change", (e) => {
            const isActive = e.target.checked;

            toggleAllCheckbox(allTableCheckbox, isActive);
        });
    }
}

function toggleAllCheckbox(selectors, isActive) {
    if (selectors.length) {
        selectors.forEach((checkbox) => {
            checkbox.checked = isActive;
        });
    }
}
